import { Meta, Uppy } from "@uppy/core";
import { atom } from "jotai";
import { UppyFile as BasicUppyFile } from '@uppy/core'
import { Floor } from "utils/floor";

export type Coords = { lat: number, lng: number } | undefined;

export type Location = {
  id: string;
  address: string;
  coords: Coords;
};

export const DEFAULT_LOCATION: Location = {
  id: "preimage-default-location-1",
  address: "HSR Layout",
  coords: undefined,
};

export type UppyFile = BasicUppyFile<Meta, Record<string, never>>;

export type NewProjectModalFloorInput = Pick<Floor, "name" | "s3Url" | "position" | "metadata">;

export const debouncedAddressAtom = atom("");
export const debouncedCoordsAtom = atom<Coords>();
export const locationSuggestionsAtom = atom<Location[]>([]);

// export const currentlyChosenAddress = atom<Location>(DEFAULT_LOCATION);
export const floorplanFilesAtom = atom<UppyFile[]>([])
export const newProjectUppyInstanceAtom = atom<Uppy | undefined>();
export const newProjectAtom = atom<Project>();
export const isUploadingProjectAssetsAtom = atom<boolean>(false);
export const newProjectFloorsAtom = atom<NewProjectModalFloorInput[]>([]);
export const addFloorModalOpenAtom = atom<boolean>(false);

export type UploadProgress = {
  fileName: string;
  progress: number;
  uploaded: boolean;
};

export const uploadProgressAtom = atom<UploadProgress[]>([]);